import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { IRootState } from "../../redux/store";
import type { Avatar, Character } from "../../utils";
import AvatarCard from "../AvatarCard/AvatarCard";
import styles from "./HomeAvatars.module.scss";
import { avatars, avatarsGender } from "../../pages/Home/constants";
import { enrichAvatarsWithGender, formatCharactersToAvatars } from "../../utils/shared";

const DEFAULT_GENDER = "female";

const HomeAvatars = () => {
	const allAvatarsList: Character[] = useSelector(
		(state: IRootState) => state.platformAvatars,
	);

	const avatarsList = useMemo(() => {
		const formatted = formatCharactersToAvatars(allAvatarsList);
		return enrichAvatarsWithGender(formatted, avatarsGender, DEFAULT_GENDER);
	}, [allAvatarsList]);

	return (
		<div className={styles.container}>
			<div className={styles.textContainer}>
				<h2 className={styles.pageSubtitle}>Аватары</h2>
				<span>Выберите аватара ниже, чтобы начать</span>
			</div>
			<div className={styles.avatars}>
				{avatarsList.map((avatar) => {
					return (
						<AvatarCard
							key={avatar.value}
							name={avatar.avatarRuName}
							description={avatar.description}
							avatarImage={avatar.url}
							gender={avatar.gender}
							id={avatar.value}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default HomeAvatars;
